module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ded"
  }, [_c('a', {
    attrs: {
      "id": "i64"
    }
  }), _c('a', {
    attrs: {
      "id": "i197"
    }
  }), _c('a', {
    attrs: {
      "id": "i206"
    }
  }), _c('a', {
    attrs: {
      "id": "i428"
    }
  }), _c('a', {
    attrs: {
      "id": "i855"
    }
  }), _c('a', {
    attrs: {
      "id": "i871"
    }
  }), _c('a', {
    attrs: {
      "id": "i1133"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-1"
    }
  }), _c('em', {
    staticClass: "italic"
  }, [_vm._v("For my wife, Suzan, "), _c('br'), _vm._v("who has put up with a lot through the years "), _c('br'), _vm._v("from this scruffy old fighter pilot")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-95e799a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Ded.vue
// module id = 66
// module chunks = 0